import slugify from 'slugify'

const routes = {
  about: '/about',
  article: '/blog/:slug',
  calendars: '/calendar',
  calendar: '/calendar/:year/:category',
  category: '/blog',
  home: '/',
  blog: '/blog',
  results: '/results',
  result: '/results/:year/:category/:track',
  standings: '/standings',
  standing: '/standings/:year/:category',
  rider: '/riders/:slug',
  riders: '/riders',
  tag: '/tags/:slug',
  track: '/tracks/:slug',
  tracks: '/tracks',
  updates: '/updates',
  contact: '/contact',
  wildcard: '*',
} as const

function generateTitleFromSlug(text: string) {
  return text
    .replace(/-/g, ' ')
    .replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase())
}

function generateSlug(text?: string) {
  if (!text) return ''
  return slugify(text, { lower: true, trim: true, remove: /[™*+~.()'"!:@]/g })
}

export { generateSlug, generateTitleFromSlug }

export default routes
